var map = {
	"./blog.yml": 71,
	"./cloud.yml": 72,
	"./color.yml": 73,
	"./country.yml": 74,
	"./dio.yml": 75,
	"./doc.yml": 76,
	"./emoji.yml": 77,
	"./git.yml": 78,
	"./icon.yml": 79,
	"./license.yml": 80,
	"./link.yml": 81,
	"./metrics.yml": 82,
	"./people.yml": 83,
	"./soft.yml": 84,
	"./src.yml": 85,
	"./status.yml": 86
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;